import { api } from './client';
import type { ScenarioDto, ScenarioVersionDetail, SimulateResult, ValidateResult } from './types';

export function listScenarios(): Promise<ScenarioDto[]> {
  return api.get<ScenarioDto[]>('/api/v1/scenarios');
}

export function getVersion(scenarioId: string, version: number): Promise<ScenarioVersionDetail> {
  return api.get<ScenarioVersionDetail>(`/api/v1/scenarios/${scenarioId}/versions/${version}`);
}

export function createScenario(name: string, definition?: Record<string, unknown>): Promise<{ id: string; name: string; version: number | null }> {
  return api.post('/api/v1/scenarios', { name, definition });
}

export function createVersion(
  scenarioId: string,
  definition: Record<string, unknown>,
): Promise<{ id: string; scenario_id: string; version: number; status: string }> {
  return api.post(`/api/v1/scenarios/${scenarioId}/versions`, { definition });
}

export function validateVersion(scenarioId: string, version: number): Promise<ValidateResult> {
  return api.post<ValidateResult>(`/api/v1/scenarios/${scenarioId}/versions/${version}/validate`);
}

export function simulateVersion(scenarioId: string, version: number, runs = 5): Promise<SimulateResult> {
  return api.post<SimulateResult>(`/api/v1/scenarios/${scenarioId}/versions/${version}/simulate`, { runs });
}

export function activateVersion(
  scenarioId: string,
  version: number,
): Promise<{ id: string; version: number; status: string }> {
  return api.post(`/api/v1/scenarios/${scenarioId}/versions/${version}/activate`);
}

export function disableVersion(
  scenarioId: string,
  version: number,
): Promise<{ id: string; version: number; status: string }> {
  return api.post(`/api/v1/scenarios/${scenarioId}/versions/${version}/disable`);
}
